

const CloseIcon = () => (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line x1="1" y1="-1" x2="23.0568" y2="-1" transform="matrix(0.706632 -0.707581 0.706632 0.707581 1 19.0002)" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <line x1="1" y1="-1" x2="23.0568" y2="-1" transform="matrix(-0.706632 -0.707581 0.706632 -0.707581 18 17.0222)" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

export default CloseIcon;